<template>
  <tbody>
    <tr v-for="(item, i) in items" :key="item.id" class="text-xs-center hovereable" @click="showStages($event, item.id)">
      <td width="10%">
        <v-icon x-large class="k-orange-linear-text text--darken-2">fas fa-code-branch fa-rotate-180</v-icon>
      </td>
      <td class="text-xs-left">
        {{ item.name }}
        <small>{{ item.description }}</small>
      </td>
      <td  width="15%">
        <v-chip medium class="green white--text" v-if="item.status === 'Activo'">
          <v-icon class="pr-2 white--text" small>fas fa-check</v-icon>
          Activo
        </v-chip>
        <v-chip medium class="grey darken-0 white--text" v-else>
          <v-icon class="pr-2 white--text" small>fas fa-times</v-icon>
          Inactivo
        </v-chip>
      </td>
      <td class="text-xs-right">
        <v-menu bottom offset-y>
          <v-btn slot="activator" color="grey darken-2" small flat fab>
            <v-icon>fas fa-ellipsis-v</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="changeStatus(item.id, item.status === 'Activo' ? 'Inactivo' : 'Activo')">
              <v-list-tile-title>{{item.status === 'Activo' ? 'Desactivar' : 'Activar'}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="editItemWithEvent(null, item.id)">
              <v-list-tile-title>Editar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="deleteItem(item.id, `el flujo ${item.name}`)">
              <v-list-tile-title>Eliminar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </tr>
  </tbody>
</template>

<script>
import EventBus from '@/event-bus';
import dataTableMixin from '@/mixins/dataTableList';

export default {
  props: ['items'],
  mixins: [
    dataTableMixin,
  ],
  methods: {
    showStages($event, id) {
      if ($event.target.className !== 'btn__content') {
        this.$router.push(`/workflow_notifications/${id}/stages`);
      }
    },
    changeStatus(id, status) {
      this.axios.patch(`workflow_notifications/${id}`, {
        status,
      }).then(() => {
        EventBus.$emit('update');
      }).catch(() => { });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/workflow_notification/WorkflowNotificationList.vue